import { BasicController, error } from "@goodgamestudios/core";
import { BasicLanguageFontManager } from "@goodgamestudios/core";
import { BasicLayoutManager } from "@goodgamestudios/core";
import { BasicToolTipManager } from "@goodgamestudios/core";
import { GGSTextAlign } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";

import { BasicTooltipVO } from "../../basic/vo/BasicTooltipVO";

import { Poker2DialogEvent } from "../event/Poker2DialogEvent";
import { Poker2Model } from "../model/Poker2Model";

import DisplayObject = createjs.DisplayObject;
import Container = createjs.Container;

import Point = createjs.Point;
import Rectangle = createjs.Rectangle;

export class Poker2ToolTipManager extends BasicToolTipManager {
    constructor(layer: Container) {
        super(layer, Library.PokerInterface.Tooltip_Body, Library.PokerInterface.Tooltip_Arrow);
        this._max_width = 225;
        this.ARROW_HEIGHT = 5;
        this.ARROW_OFFSET = 0;
        this._textField.getTextFormat().size = 14;
        BasicController.getInstance().addEventListener("changelayoutstate", this.bindFunction(this.handleChangeLayoutState));
    }

    protected updateTextField(): void {
        this._textField.y = this._standardTextFieldY;
    }

    /**
     * Also update the tooltips's textfield if the last state of the app has been login, avatar creation or
     * preload_connected (ususally this happens if a user logs in and enters the lobby).
     */
    protected handleChangeLayoutState(event: Poker2DialogEvent): void {
        if (event.params[1] == 2 ||
            event.params[1] == BasicLayoutManager.STATE_AVATAR_CREATION ||
            event.params[1] == BasicLayoutManager.STATE_PRELOAD_CONNECTED
        ) {
            this.updateTextField();
        }
    }

    public destroy(): void {
        super.destroy();

        BasicController.getInstance().removeEventListener("changelayoutstate", this.bindFunction(this.handleChangeLayoutState));
    }

    protected get languageFontmanager(): BasicLanguageFontManager {
        return Poker2LanguageFontManager.getInstance();
    }

    protected get poker2LanguageFontmanager(): Poker2LanguageFontManager {
        return Poker2LanguageFontManager.getInstance();
    }

    public show(toolTipText: string, target: DisplayObject = null): void {
        if (Poker2LayoutManager.getInstance().currentState == 2
            || Poker2Model.userData.gamePropertiesVO == null || Poker2Model.userData.gamePropertiesVO.showTooltip)
            super.show(toolTipText, target);
    }

    protected flipHorizontalToolTip(ttHeight: number, buttonBounds: Rectangle, globalPos: Point): number {
        //			if(tipY + (buttonBounds.top - toolTipHeight - ARROW_OFFSET - ARROW_HEIGHT)*_disp.scaleY  < 0)
        return int((ttHeight + this.ARROW_OFFSET + this.ARROW_HEIGHT) * this._disp.scaleY);
        //			return = globalPos.y + (buttonBounds.bottom + ttHeight + ARROW_OFFSET + ARROW_HEIGHT) * _disp.scaleY;
    }

    public updatePosition(): void {
        // if (this.disp && this.disp.stage) {
        //     this.disp.scaleX = this.disp.scaleY = 1;//this.disp.stage.stageHeight / 600;
        // }
    }

    /*override*/ protected assignToolTipText(toolTipText: any): void {

        if ((typeof toolTipText === 'string')) {

            var toolTipArray: any[] = toolTipText.split("$$");
            var toolTipId: string = toolTipArray.shift();

            if (toolTipArray.length > 0) {
                var paramString: string = toolTipArray[0];
                var params: any[] = paramString.split(",");

                if (this.registrationIsNeeded()) {
                    this._ggsTextField = this.textFieldManager.registerTextField(this._textField, new LocalizedTextVO(toolTipId, params));
                    this._ggsTextField.textAlign = GGSTextAlign.CENTER;
                }
                else {
                    this._ggsTextField.textContentVO = new LocalizedTextVO(toolTipId, params);
                }
            }
            else {
                if (this.registrationIsNeeded()) {
                    this._ggsTextField = this.textFieldManager.registerTextField(this._textField, new LocalizedTextVO(toolTipId));
                    this._ggsTextField.textAlign = GGSTextAlign.CENTER;
                }
                else {
                    this._ggsTextField.textContentVO = new LocalizedTextVO(toolTipId);
                }
            }
        }
        else if (instanceOfClass(toolTipText, "AbstractTextContentVO")) {
            if (this.registrationIsNeeded()) {
                this._ggsTextField = this.textFieldManager.registerTextField(this._textField, toolTipText as AbstractTextContentVO);
                this._ggsTextField.textAlign = GGSTextAlign.CENTER;
            }
            else {
                this._ggsTextField.textContentVO = toolTipText as AbstractTextContentVO;
            }
        }
        else {
            // object format... t -> textId, p -> paramArray
            if (toolTipText.hasOwnProperty("t")) {
                if (this.registrationIsNeeded()) {
                    this._ggsTextField = this.textFieldManager.registerTextField(this._textField, new LocalizedTextVO(toolTipText.t, toolTipText.p));
                }
                else {
                    this._ggsTextField.textContentVO = new LocalizedTextVO(toolTipText.t, toolTipText.p);
                }
            }
            else {
                error(new Error("Invalid paramobject for textfield: " + toolTipText.toString()).stack);
            }
        }
    }

    private registrationIsNeeded(): boolean {
        return !this._ggsTextField;
    }

    /**
     *
     * Erzeugt einen erweiterten Tooltip
     *
     * @param vo:TooltipVO
     * @param target:DisplayObject
     */
    public showAdvancedTooltip(vo: BasicTooltipVO, target: DisplayObject = null): void {
        //TODO
    }

    /**
     *
     * Löscht einen erweiterten Tooltip
     */
    public hideAdvancedTooltip(): void {

        //TODO
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set languageFontmanager(value/*:BasicLanguageFontManager*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicToolTipManager.prototype, "languageFontmanager").set.call(this, value);
    }
}
import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import { AbstractTextContentVO } from "@goodgamestudios/localization";
import { LocalizedTextVO } from "@goodgamestudios/localization";
import { Poker2LanguageFontManager } from "./Poker2LanguageFontManager";
import { Poker2LayoutManager } from "./Poker2LayoutManager";
